import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import Hero from "@/components/Hero";
import ProgressSection from "@/components/ProgressSection";
import TierGrid from "@/components/TierGrid";
import WallOfSupport from "@/components/WallOfSupport";
import StorySection from "@/components/StorySection";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";
import DonateModal from "@/components/DonateModal";
import PledgeModal from "@/components/PledgeModal";
import AIChatBubble from "@/components/AIChatBubble";

export default function Home() {
  const [stats, setStats] = useState(null);
  const [wall, setWall] = useState([]);
  const [donateOpen, setDonateOpen] = useState(false);
  const [pledgeOpen, setPledgeOpen] = useState(false);
  const [preset, setPreset] = useState({ amount: "", tier_id: "" });

  const load = useCallback(async () => {
    try {
      const [c, w] = await Promise.all([api.get("/campaign"), api.get("/wall")]);
      setStats(c.data);
      setWall(w.data);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openDonate = (p = {}) => { setPreset(p); setDonateOpen(true); };
  const openPledge = (p = {}) => { setPreset(p); setPledgeOpen(true); };

  return (
    <div className="min-h-screen bg-blueprint">
      <SiteHeader onDonate={() => openDonate()} />
      <Hero onDonate={() => openDonate()} onPledge={() => openPledge()} stats={stats} />
      <ProgressSection stats={stats} />
      <StorySection />
      <TierGrid tiers={stats?.tiers || []} onDonate={openDonate} onPledge={openPledge} />
      <WallOfSupport items={wall} />
      <Footer />
      <DonateModal
        open={donateOpen}
        onClose={() => setDonateOpen(false)}
        preset={preset}
        onSuccess={load}
      />
      <PledgeModal
        open={pledgeOpen}
        onClose={() => setPledgeOpen(false)}
        preset={preset}
        onSuccess={load}
      />
      <AIChatBubble />
    </div>
  );
}
